<template>
  <div style="width: 1627px;">
    <div class="Title">
      今日提醒
      <img src="@/assets/images/wpsp/Home/问号.png" />
      <span>点击提醒类别筛选客户列表，再次点击提醒类别取消筛选</span>
    </div>
    <div class="remind">
      <div v-for="(v,i) in getRemindTodayData"
           :key="i">
        <span>
          <div class="number"
               v-for="(value,index) in getRemindTodayData"
               :key="index"
               @click="getCustomerList(value.cisList)">
            <span v-if="value.remindType*1===i+1&&value.cisList!==undefined">{{value.cisList.length}}</span>
            <span v-if="value.remindType*1===i+1&&value.cisList===undefined">0</span>
          </div>
          <div class="text">{{v.remindType==='1'?'风险评估到期':
            v.remindType==='2'?'风险等级变动':v.remindType==='3'?
            '资产配置异常':v.remindType==='4'?'保险保障异常':
            v.remindType==='5'?'长期未规划':'家庭成员变动'}}
          </div>
        </span>
        <span class="img">
          <img v-if="v.remindType==='1'"
               src="@/assets/images/wpsp/Home/风险评估到期.png"
               alt />
          <img v-if="v.remindType==='2'"
               src="@/assets/images/wpsp/Home/风险等级变动.png"
               alt />
          <img v-if="v.remindType==='3'"
               src="@/assets/images/wpsp/Home/资产配置异常.png"
               alt />
          <img v-if="v.remindType==='4'"
               src="@/assets/images/wpsp/Home/保险保障异常.png"
               alt />
          <img v-if="v.remindType==='5'"
               src="@/assets/images/wpsp/Home/长期未规划.png"
               alt />
          <img v-if="v.remindType==='6'"
               src="@/assets/images/wpsp/Home/家庭成员变动.png"
               alt />
        </span>
      </div>
    </div>
    <div class="Title">客户列表</div>
    <div>
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="客户号">
          <el-input v-model="formInline.cis"
                    placeholder="请输入客户号"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名">
          <el-input v-model="formInline.name"
                    placeholder="请输入客户姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="formInline.gender"
                     placeholder="请选择">
            <el-option label="男"
                       value="1">
            </el-option>
            <el-option label="女"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄范围">
          <span style="display: flex;flex-direction: row;">
            <el-input v-model="formInline.minAge"
                      placeholder="年龄下限"></el-input>至
            <el-input v-model="formInline.maxAge"
                      placeholder="年龄上限"></el-input>
          </span>
        </el-form-item>
        <br />
        <el-form-item label="风险等级">
          <el-select v-model="formInline.risk"
                     placeholder="请选择">
            <el-option v-for="item in options"
                       :key="item.dictValue"
                       :label="item.dictName"
                       :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="季日均">
          <span style="display: flex;flex-direction: row;">
            <el-input v-model="formInline.minAssets"
                      placeholder="资产下限"></el-input>至
            <el-input v-model="formInline.maxAssets"
                      placeholder="资产上限"></el-input>
          </span>
        </el-form-item>
      </el-form>
      <el-button type="primary"
                 @click="query">查询</el-button>
      <el-button @click="empty">清空查询条件</el-button>
    </div>
    <div>
      <el-table :data="tableData">
        <el-table-column label="客户号"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.cis }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style="color:#1E88FF;cursor:pointer;"
                  @click="customerView(scope.row)">{{ scope.row.custName }}</span>
            <!-- <span style="color:#1E88FF;cursor:pointer;">{{ scope.row.custName }}</span> -->
          </template>
        </el-table-column>
        <el-table-column label="性别"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.gender|genderFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年龄"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.age }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style="color:#1E88FF;cursor:pointer;">{{ scope.row.mobileNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="季日均资产"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.Assets }}</span>
          </template>
        </el-table-column>
        <el-table-column label="风险等级"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.riskLevelRes }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户资产"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{ scope.row.assetSize }}</span>
          </template>
        </el-table-column>
        <el-table-column label="未联系天数"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <span style>{{scope.row.lastCallTime*1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         fixed="right"
                         width="200">
          <template slot-scope="scope">
            <div style="display: flex;flex-direction: row;align-items:center;">
              <!-- <el-button type="text"
                         @click="Analysis(scope.row)">分析</el-button>
              <el-button type="text"
                         @click="configure">配置</el-button>
              <el-button type="text">保障</el-button>
               <el-popover trigger="hover"
                          placement="top">
                <div style="display: flex;justify-content:space-around;">
                  <el-button type="text"
                             @click="children(scope.row)">子女</el-button>
                  <el-button type="text"
                             @click="Pension(scope.row)">养老</el-button>
                  <el-button type="text"
                             @click="Presentation(scope.row)">报告</el-button>
                </div>
                <div slot="reference">
                  <img src="@/assets/images/wpsp/Home/更多.png"
                       alt />
                </div>
              </el-popover> -->
              <el-button type="text"
                         @click="configure(scope.row)">配置</el-button>
              <el-button type="text"
                         @click="children(scope.row)">子女</el-button>
              <el-button type="text"
                         @click="Pension(scope.row)">养老</el-button>
              <el-button type="text"
                         @click="Presentation(scope.row)">报告</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-size="pageSize"
                   layout="total, prev, pager, next, jumper"
                   :total="total">
    </el-pagination>
  </div>
</template>
<script>
import { addNav } from '@/mixins';

export default {
  mixins: [addNav],
  data() {
    return {
      userId: '',
      token: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      getRemindTodayData: {},
      options: [],
      formInline: {
        cis: '', // 客户号
        name: '', // 客户姓名
        gender: '', // 性别
        minAge: '', // 年龄下限
        maxAge: '', // 年龄上限
        risk: '', // 风险等级
        layered: '', // 客户分层
        customerGroup: '', // 客户客群
        minAssets: '', // 资产下限
        maxAssets: '', // 资产上限
      },
      tableData: [],
      // 当前系统日期
      currentDate: '',
      cisList: [],
    };
  },
  computed: {},
  mounted() {
    if (
      this.$route.query.userId !== undefined
      || this.$route.query.userToken !== undefined
      || this.$route.query.sessionData1 !== undefined
    ) {
      const sessionData = JSON.parse(this.$route.query.sessionData);
      sessionStorage.setItem(
        'userId',
        JSON.stringify(this.$route.query.userId),
      );
      sessionStorage.setItem(
        'userToken',
        JSON.stringify(this.$route.query.userToken),
      );
      sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    }
    // 获取当前年月日
    const myDate = new Date();
    this.currentDate = `${myDate.getFullYear()}-${
      myDate.getMonth() + 1
    }-${myDate.getDate()}`;
    this.getRemindToday();
    this.getCustomerList();
    this.riskLevel();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCustomerList();
    },
    empty() {
      this.formInline = {
        cis: '', // 客户号
        name: '', // 客户姓名
        gender: '', // 性别
        minAge: '', // 年龄下限
        maxAge: '', // 年龄上限
        risk: '', // 风险等级
        layered: '', // 客户分层
        customerGroup: '', // 客户客群
        minAssets: '', // 资产下限
        maxAssets: '', // 资产上限
      };
    },
    customerView(row) {
      // console.log(id);
      // window.location.href = 'http://192.168.30.89:8081/#/customer-viewer-Two?customerId=4206940';
      this.addNav({
        name: '客户视图',
        path: '/CustomerView',
        query: {},
      });
      sessionStorage.setItem('customer', JSON.stringify(row));
    },
    // 跳转资产分析
    Analysis(row) {
      this.addNav({
        name: '资产分析',
        path: '/CustomerView-Home',
        query: {},
      });
      sessionStorage.setItem('customer', JSON.stringify(row));
    },
    // 跳转资产配置
    configure(row) {
      this.addNav({
        name: '资产配置',
        path: '/finance-config',
        query: {},
      });
      sessionStorage.setItem('customer', JSON.stringify(row));
    },
    // 跳转子女
    children(row) {
      console.log(row);
      if (row.riskLevelRes !== undefined) {
        this.addNav({
          name: '子女规划',
          path: '/children-educationHome',
          query: {
            row,
          },
        });
        this.save_redis_custinfo(row);
      } else {
        this.$message.error('客户未进行风评');
      }
    },
    // 跳转养老
    Pension(row) {
      if (row.riskLevelRes !== undefined) {
        this.addNav({
          name: '养老规划',
          path: '/pension-planningHome',
          query: {
            row,
          },
        });
        this.save_redis_custinfo(row);
      } else {
        this.$message.error('客户未进行风评');
      }
    },
    save_redis_custinfo(row) {
      const parames = {
        data: {
          custInfomation: row,
        },
      };
      this.$_post(this.$API.save_redis_custinfo, parames).then((res) => {
        console.log(res);
      });
    },
    // 跳转财富报告
    Presentation(row) {
      if (row.riskLevelRes !== undefined) {
        this.addNav({
          name: '财富报告',
          path: '/Presentation',
          query: {
            row,
          },
        });
        this.save_redis_custinfo(row);
      } else {
        this.$message.error('客户未进行风评');
      }
    },
    query() {
      this.currentPage = 1;
      this.getCustomerList();
    },
    // 今日提醒
    getRemindToday() {
      console.log(
        JSON.parse(sessionStorage.getItem('sessionData')),
        '11111111111111',
      );
      const parames = {
        data: {
          userId: JSON.parse(sessionStorage.getItem('userId')),
          token: JSON.parse(sessionStorage.getItem('userToken')),
          dataAuth: JSON.parse(sessionStorage.getItem('sessionData')).dataAuth, // 类型：String  必有字段  备注：无
          workNo: JSON.parse(sessionStorage.getItem('sessionData')).workNo, // 类型：String  必有字段  备注：无
          orgnCode: JSON.parse(sessionStorage.getItem('sessionData')).orgnCode, // 类型：String  必有字段  备注：无
        },
      };
      this.$_post(this.$API.get_remind_today, parames).then((res) => {
        console.log(res);
        this.getRemindTodayData = res.data.list;
      });
    },
    // 查询风险等级下拉框
    riskLevel() {
      const parames = {
        data: {
          userId: JSON.parse(sessionStorage.getItem('userId')),
          token: JSON.parse(sessionStorage.getItem('userToken')),
          dictTypeCode: 'customerRiskLevel',
        },
      };
      this.$_post(this.$API.get_dict_list, parames).then((res) => {
        console.log(res);
        this.options = res;
      });
    },
    // 查列表
    getCustomerList(cisList) {
      if (cisList === undefined || this.cisList === cisList) {
        this.cisList = [];
      } else {
        this.cisList = cisList;
      }
      const parames = {
        data: {
          userId: JSON.parse(sessionStorage.getItem('userId')),
          token: JSON.parse(sessionStorage.getItem('userToken')),
          cis: this.formInline.cis, // 类型：String  可有字段  备注：用户cis
          custName: this.formInline.name, // 类型：String  可有字段  备注：用户姓名
          mobileNumber: '', // 类型：String  可有字段  备注：手机号
          certificateNumber: '', // 类型：String  可有字段  备注：身份证
          ifPlanNonExecution: '', // 类型：String  可有字段  备注：是否有未执行计划
          ageStart: this.formInline.minAge, // 类型：String  可有字段  备注：年龄查询起点
          ageEnd: this.formInline.maxAge, // 类型：String  可有字段  备注：年龄查询终点
          lastCallTimeStart: '', // 类型：String  可有字段  备注：最后一次电访开始时间
          ownedOrgnCode: [], // 类型：Array  可有字段  备注：归属机构集合
          lastCallTimeEnd: '', // 类型：String  可有字段  备注：最后一次电访技术时间
          orderKey: '', // 类型：String  可有字段  备注：最后一次访问时间排序标识
          orderFlag: '', // 类型：String  可有字段  备注：最新电访时间排序标识
          riskLevel: this.formInline.risk, // 类型：String  可有字段  备注：客户风险等级
          customerLifeCycleType: '', // 类型：String  可有字段  备注：客户生命周期类型
          lossWarningType: '', // 类型：String  可有字段  备注：流失预警类型
          gender: this.formInline.gender, // 类型：String  可有字段  备注：性别
          customerStratification: this.formInline.layered, // 类型：String  可有字段  备注：客户分层
          quarterlyAverageAssets: '', // 类型：String  可有字段  备注：季日均
          cisList: this.cisList, // 类型：Array  可有字段  备注：客户号集合
        },
        pageMessage: {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      this.$_post(this.$API.customerList, parames).then((res) => {
        this.tableData = res.data.list;
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].lastCallTime = this.DateDiff(
            this.currentDate,
            this.formatToD(this.tableData[i].lastCallTime * 1),
          );
        }
        this.total = res.sumCount;
      });
    },
    // 计算天数
    DateDiff(sDate1, sDate2) {
      // sDate1和sDate2是2006-12-18格式
      let aDate;
      let oDate1;
      let oDate2;
      let iDays;
      aDate = sDate1.split('-');
      oDate1 = new Date(aDate[0], aDate[1], aDate[2]); // 转换为12-18-2006格式
      aDate = sDate2.split('-');
      oDate2 = new Date(aDate[0], aDate[1], aDate[2]);
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); // 把相差的毫秒数转换为天数
      return iDays;
    },
  },
};
</script>
<style lang="scss">
.Title {
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  color: rgba(48, 49, 51, 1);
  line-height: 24px;
  img {
    margin-left: 7px;
    position: relative;
    top: 2px;
  }
  span {
    font-size: 12px;
    font-weight: 400;
    color: rgba(144, 147, 153, 1);
    margin-left: 7px;
  }
  margin-bottom: 16px;
}
.remind {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 32px;
  > div {
    padding: 16px 12px 18px 20px;
    width: 13%;
    height: 80px;
    background: rgba(30, 136, 255, 1);
    display: flex;
    flex-direction: row;
    .number {
      font-size: 32px;
      font-family: HelveticaNeue-Bold, HelveticaNeue;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
    }
    .text {
      font-size: 14px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      line-height: 21px;
      margin-top: 14px;
    }
    .img {
      margin-left: 15px;
    }
  }
}
</style>
